import { render } from "./WaveCardSmall.vue?vue&type=template&id=c8aba92a&scoped=true"
import script from "./WaveCardSmall.vue?vue&type=script&lang=js"
export * from "./WaveCardSmall.vue?vue&type=script&lang=js"

import "./WaveCardSmall.vue?vue&type=style&index=0&id=c8aba92a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8aba92a"]])

export default __exports__